module.exports = __webpack_public_path__ + "static/img/quanjing_02.526edce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanjing_02.png
// module id = lpMz
// module chunks = 1